<template>
    <!-- 产品说明详情页 -->
    <div class="instructions_detail_box">
        <div class="container instructions_detail_bg">
            <div class="instructions_detail_title">{{instr_detail.title}}</div>
            <div class="instructions_detail_subtitle">{{instr_detail.subtitle}}</div>
            <div v-html="instr_detail.content"></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
    computed: mapState({
        instr_detail: state => state.instructions.instr_detail,
    }),
    methods: {
        ...mapMutations([
            "setInstructionsDetail"
        ]),
        ...mapActions([
            "getInstructionsDetail"
        ]),
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.getInstructionsDetail(to.query.id)
        })
    },
    beforeRouteLeave (to, from, next) {
        this.setInstructionsDetail({});
        next();
    }
}
</script>

<style scoped>
/* 产品说明详情页盒子 */
.instructions_detail_box{
    /* margin-top: 182px; */
    margin: 30px 0;
}
/* 产品说明详情页背景 */
.instructions_detail_bg{
    background-color: #fff;
    padding: 50px;
}
/* 标题 */
.instructions_detail_title{
    text-align: center;
    margin-bottom: 20px;
    font-size: 25px;
    font-weight: bold;
}
/* 小标题 */
.instructions_detail_subtitle{
    text-align: center;
    margin-bottom: 30px;
    color: #909399;
}
</style>
